import { State, selectAppPreview } from '../../index'

export const selectTikTok = (state: State) => selectAppPreview(state).tikTok
export const selectTikTokFirstStepData = (state: State) => selectTikTok(state).step1
export const selectTikTokInterpolationListData = (state: State) => selectTikTok(state).interpolationListData
